import { useEffect } from 'react';

import { useBoolean } from '@trend-dev/ui-libs-utils/hooks/useBoolean';
import { useUpdatedRef } from '@trend-dev/ui-libs-utils/hooks/useUpdatedRef';

import { useYM } from 'YM/Context';
import { GoalType } from 'YM/declare';

export function useScreenShareMetrics(screenShareState: boolean) {
    const { triggerYM } = useYM();
    const triggerYMRef = useUpdatedRef(triggerYM);
    const [screenShareMetricsCanBeSent, { on: setScreenShareMetricsCanBeSent }] = useBoolean(false);
    const screenShareMetricsCanBeSentRef = useUpdatedRef(screenShareMetricsCanBeSent);

    useEffect(() => {
        if (screenShareMetricsCanBeSentRef.current) {
            const metricsGoal = screenShareState ? GoalType.CONFERENCE_PAGE_SCREEN_SHARE_START : GoalType.CONFERENCE_PAGE_SCREEN_SHARE_END;

            triggerYMRef.current({ goal: metricsGoal });
        } else {
            setScreenShareMetricsCanBeSent();
        }
    }, [screenShareState]);
}
